export { EDITOR_TYPE, DateEditor } from "./dateEditor.mjs";


//////////////////
// WEBPACK FOOTER
// ./~/handsontable/editors/dateEditor/index.mjs
// module id = 312
// module chunks = 1